import type { PaginationMetadata, PaginationQuery } from './common'
import type { RawMaterialKind } from './raw-material'

export const STOCK_OPNAME_TYPES = ['raw_material', 'product'] as const
export type StockOpnameType = (typeof STOCK_OPNAME_TYPES)[number]

export const STOCK_OPNAME_TYPE_LABELS: Record<StockOpnameType, string> = {
  raw_material: 'Bahan Baku',
  product: 'Produk Siap Jual',
}

export const STOCK_OPNAME_STATUSES = ['draft', 'completed', 'cancelled'] as const
export type StockOpnameStatus = (typeof STOCK_OPNAME_STATUSES)[number]

export const STOCK_OPNAME_STATUS_LABELS: Record<
  StockOpnameStatus,
  { label: string; variant: 'default' | 'outline' | 'secondary' | 'destructive' }
> = {
  draft: { label: 'Draft / Berjalan', variant: 'secondary' },
  completed: { label: 'Selesai', variant: 'default' },
  cancelled: { label: 'Dibatalkan', variant: 'destructive' },
}

export interface StockOpnameItem {
  id: string
  stockOpnameId: string
  itemId: string
  itemName: string
  itemSku: string | null
  itemType: 'raw_material' | 'product'
  kind?: RawMaterialKind | null
  packQty?: number | null
  categoryName?: string | null
  uomId: string
  uomName: string
  systemOnHand: number
  countedOnHand: number | null
  diffOnHand: number
  systemRepacking: number
  countedRepacking: number | null
  diffRepacking: number
  reasonId: string | null
  reasonName?: string | null
  note: string | null
  costPerUnit: number
  createdAt?: string
  updatedAt?: string
}

export interface StockOpname {
  id: string
  workspaceId: string
  code: string
  date: string
  type: StockOpnameType
  status: StockOpnameStatus
  note: string | null
  cancelReason: string | null
  totalItems: number
  discrepancyCount: number
  netDifferenceValue: number
  completedAt: string | null
  createdBy: string | null
  createdByName?: string | null
  items?: StockOpnameItem[]
  createdAt: string
  updatedAt: string
}

export interface CreateStockOpnameReq {
  date?: string
  type: StockOpnameType
  note?: string | null
}

export interface AddStockOpnameItemsReq {
  itemIds: string[]
}

export interface UpdateStockOpnameItemInput {
  id: string
  countedOnHand?: number | null
  countedRepacking?: number | null
  reasonId?: string | null
  note?: string | null
}

export interface UpdateStockOpnameReq {
  date?: string
  note?: string | null
  items?: UpdateStockOpnameItemInput[]
}

export interface CompleteStockOpnameReq {
  items?: UpdateStockOpnameItemInput[]
}

export interface CancelStockOpnameReq {
  cancelReason: string
}

export interface GetStockOpnameListReq extends PaginationQuery {
  type?: StockOpnameType
  status?: StockOpnameStatus
  search?: string
  startDate?: string
  endDate?: string
}

export interface StockOpnameListRes {
  items: StockOpname[]
  pagination: PaginationMetadata
}
